<div id="imageoneSetting" *ngIf="imageoneSetting">
    <imageone-setting [pageDisplay]="pageDisplay" [pageTitle]="pageTitle" [id]="id">hi
    </imageone-setting>
</div>